export function parseAgreement(result) {
    const agreement = result.data.agreement;
    if (!agreement) {
        throw new Error('Unable to parse agreement.');
    }
    return {
        id: agreement.id,
        dao: agreement.dao,
        stakingFactory: agreement.stakingFactory,
        currentVersionId: agreement.currentVersion.id,
    };
}
//# sourceMappingURL=agreement.js.map